import { eReportTamThuActionsObj } from "../../action-types/report/IReportTamThuActionTypes";
import { generateActions } from "../generateActions";

export const reportTamThuActions = {
  ...generateActions(eReportTamThuActionsObj, "REPORT_TAM_THU"),
};
